// Login
export const LOGIN = "AUTH-LOGIN/LOGIN";
export const LOGIN_SUCCESS = "AUTH-LOGIN/LOGIN_SUCCESS";

// Fetch Home Feed
export const FETCH_HOME_FEED = "HOME/FETCH_HOME_FEED";
export const FETCH_HOME_FEED_SUCCESS = "HOME/FETCH_HOME_FEED_SUCCESS";

// Fetch Wallet Txns
export const FETCH_WALLET_TXNS = "TXNS/FETCH_WALLET_TXNS";
export const FETCH_WALLET_TXNS_SUCCESS = "TXNS/FETCH_WALLET_TXNS_SUCCESS";

// Send OTP
export const SEND_OTP = "AUTH-SEND_OTP/SEND_OTP";
export const SEND_OTP_SUCCESS = "AUTH-SEND_OTP/SEND_OTP_SUCCESS";

// Verify OTP
export const VERIFY_OTP = "AUTH-VERIFY_OTP/VERIFY_OTP";
export const VERIFY_OTP_SUCCESS = "AUTH-VERIFY_OTP/VERIFY_OTP_SUCCESS";

//Loader
export const SET_LOADING_STATUS = "LOADER/SET_LOADING_STATUS";
export const REMOVE_LOADING_STATUS = "LOADER/REMOVE_LOADING_STATUS";

// Logout
export const LOGOUT = "AUTH-LOGOUT/LOGOUT";
export const LOGOUT_SUCCESS = "AUTH-LOGOUT/LOGOUT_SUCCESS";
